import { Team } from '@internal/schemas-common';
import { useLogger } from '../../utils/logger';
import { Entity, isGroupEntity } from '@backstage/catalog-model';

export function mapGroupEntitiesToTeams(
  entities: Entity[] | undefined,
  logger: ReturnType<typeof useLogger>,
): Team[] {
  if (!entities?.length) return [];

  return entities.filter(isGroupEntity).reduce<Team[]>((acc, entity) => {
    const ref = entity.metadata.name;

    const picture = (entity.spec as any)?.profile?.picture;
    if (!picture) {
      logger.info(`No picture found for group ${ref}.`);
    }

    const namespace = entity.metadata.namespace ?? 'default';
    if (!entity.metadata.namespace) {
      logger.info(
        `Namespace not set for group ${ref}, defaulting to 'default'.`,
      );
    }

    const displayName = (entity.spec as any)?.profile?.displayName;
    if (!displayName) {
      logger.info(`No display name found for group ${ref}.`);
    }

    const parentRef = (entity.spec as any)?.parent as string | undefined;

    const maybeTeam = Team.createIfCorrectFormat(
      ref,
      displayName,
      namespace,
      picture,
      undefined,
      parentRef,
    );
    if (maybeTeam) {
      acc.push(maybeTeam);
    } else {
      logger.info(`Entity ${ref} did not match Team format and was skipped.`);
    }

    return acc;
  }, []);
}
